<template>
  <div class="transfer-user__container">
    <b-row class="my-1">
      <b-col sm="9">
        <b-alert show class="mb-4" v-if="ssoStatus.length > 0">
          <div><span v-html="$t('ManageLoginComponent_AccountExternal.Headline_ExternalUserWithNoIdentity')"/></div>
          <div><span v-html="$t('ManageLoginComponent_AccountExternal.SubHeadline_ExternalUserWithNoIdentity')" /></div>
        </b-alert>
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col sm="9">
        <b-alert
          :show="confirmationSend"
          dismissible
          variant="success"
        >
          <h1 v-html="$t('ManageIdentity.Views.Account.ConfirmationSend.ConfirmationSendHeadline')" />
          <span v-html="$t('ManageIdentity.Views.Account.ConfirmationSend.ConfirmationSendText')" />
        </b-alert>
        <b-alert
          :show="passwordInfo"
          dismissible
          variant="primary"
          @dismissed="passwordInfo=false"
        >
          <h6 v-html="$t('ManageIdentity.Views.Account.Register.PasswordHintHeading')" />
          <span v-html="$t('ManageIdentity.Views.Account.Register.SubHeadline')" />
        </b-alert>
        <b-alert
          :show="!passwordIdentical"
          variant="danger"
        >
          <span v-html="$t('ManageIdentity.Views.Account.Register.ErrorConfirmPassword')" />
        </b-alert>
        <b-alert
          :show="password.length && !passwordState"
          variant="danger"
        >
          <span v-html="$t('ManageIdentity.Views.Account.Register.ErrorRequirementPassword')" />
        </b-alert>
        <template v-if="!submitted">
          <b-form-group>
            <label>{{ $t('ManageIdentity.Views.Account.Register.newpsw_transfer') }}</label> <br />
            <slot
              id="fieldset-4"
              name="label"
            >
              <span
                class="labelIcon"
              >
                {{ passwordInf }}
                <font-awesome-icon
                  :icon="['fas', 'info-circle']"
                  class="faIcon"
                  @click="openPasswordInfo()"
                />
              </span>
            </slot>
            <div class="password-input-container">
              <b-form-input
                v-if="showPassword"
                id="transfer-user__new-password"
                v-model="password"
                :state="passwordState"
                :disabled="submitted"
                type="text"
              />
              <b-form-input
                v-else
                id="transfer-user__new-password"
                v-model="password"
                :state="passwordState"
                :disabled="submitted"
                type="password"
              />
              <div>
                <button v-if="showPassword" class="btn btn-primary" @click="toggleShow">
                  <font-awesome-icon :icon="['fas', 'eye-slash']" />
                </button>
                <button v-else class="btn btn-primary" @click="toggleShow">
                  <font-awesome-icon :icon="['fas', 'eye']" />
                </button>
              </div>
            </div>
            <label :for="'transfer-user__confirm-password'">
              {{ $t('ManageIdentity.Views.Account.Register.ConfirmPassword') }}
            </label>
            <div class="password-input-container">
              <b-form-input
                v-if="showPasswordConfirm"
                id="transfer-user__confirm-password"
                v-model="passwordConfirm"
                :state="confirmPasswordState"
                :disabled="submitted"
                type="text"
              />
              <b-form-input
                v-else
                id="transfer-user__confirm-password"
                v-model="passwordConfirm"
                :state="confirmPasswordState"
                :disabled="submitted"
                type="password"
              />
              <div>
                <button v-if="showPasswordConfirm" class="btn btn-primary" @click="toggleShowConfirm">
                  <font-awesome-icon :icon="['fas', 'eye-slash']" />
                </button>
                <button v-else class="btn btn-primary" @click="toggleShowConfirm">
                  <font-awesome-icon :icon="['fas', 'eye']" />
                </button>
              </div>
            </div>
            <!-- Terms and conditions checkbox -->
            <b-form-checkbox
              id="checkbox-1"
              v-model="acceptTermsOfUse"
              name="checkbox-1"
            >
              <span>
                <a
                  href="javascript:void(0)"
                  @click="openModal(true)"
                >
                  <span>{{ $t('ManageIdentity.Views.Account.Register.AcceptTerms') }}</span></a>
              </span>
            </b-form-checkbox>
            <b-button
              :disabled="!passwordState || !passwordIdentical || !acceptTermsOfUse"
              variant="primary"
              @click.prevent="handleAccountTransfer()"
              class="mt-2"
            >
              {{ $t('ManageIdentity.Views.Account.ManageForgotPassword.Submit') }}
            </b-button>
          </b-form-group>
        </template>
        <template v-else>
          <b-button
            class="transfer-user__button-login"
            variant="primary"
            @click.prevent="redirectToUserSync"
          >
            {{ $t('ManageIdentity.Views.Account.Register.btnContinue') }}
          </b-button>
        </template>
      </b-col>
    </b-row>
    <modal
      :show="termsModal.show"
      @close="termsModal.show = false"
    >
      <b-card
        class="terms-card"
      >
        <div
          class="terms-card__close-button"
          @click.prevent="termsModal.show = false"
        >
          &times;
        </div>
        <b-card-title>
          {{ $t(termsModalTitle) }}
        </b-card-title>
        <b-card-text>{{ $t('ManageIdentity.Views.Account.Terms.SubHeadline') }}</b-card-text>
        <b-tabs card>
          <b-tab
            :title="termsTitle"
            active
          >
            <b-card-text
              class="modal-text-scroll"
              v-html="tnc"
            />
          </b-tab>
          <b-tab :title="dataProtectionTitle">
            <b-card-text
              class="modal-text-scroll"
              v-html="data"
            />
          </b-tab>
          <template v-if="getConfig.context === 'Event'">
            <b-tab :title="termsTitleOrg" v-if="tncOrg">
              <b-card-text class="modal-text-scroll" v-html="tncOrg" />
            </b-tab>
            <b-tab :title="dataProtectionTitleOrg" v-if="dataOrg">
              <b-card-text class="modal-text-scroll" v-html="dataOrg" />
            </b-tab>
          </template>
        </b-tabs>
        <b-button
          variant="success"
          @click.prevent="termsModal.show = false"
        >
          {{ $t('ManageIdentity.Views.Account.Register.btnClose') }}
        </b-button>
        <!--        <b-form-checkbox-->
        <!--          id="checkbox-1"-->
        <!--          v-model="acceptTermsOfUse"-->
        <!--          name="checkbox-1"-->
        <!--        >-->
        <!--          <span>{{ $t('ManageIdentity.Views.Account.Register.AcceptTerms') }}</span>-->
        <!--        </b-form-checkbox>-->
      </b-card>
    </modal>
  </div>
</template>

<script>
import accountPageMixins from '../mixins/accountPageMixins'
import * as constants from '../constants/constants'
import utils from '~/utilities/utils'

export default {
  async mounted() {
      await this.loadTermsAndConditions()   
  },

  data() {
    return {
      password: '',
      passwordConfirm: '',
      showPassword: false,
      showPasswordConfirm: false,      
      passwordInfo: true,
      acceptTermsOfUse: false,
      confirmationSend: false,
      submitted: false,
      responseData: {
        token: '',
        redirectUrl: ''
      },
    }
  },
  mixins: [accountPageMixins],
  props: {
    userData: {
      type: Object,
      default() {
        return {}
      }
    },
    ssoStatus: {
      type: String,
      default: ''
    },
    withSso: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    passwordRegex() {
      return constants.passwordRegex
    },
    passwordState() {
      return this.passwordRegex.test(this.password)
    },
    confirmPasswordState() {
      return this.passwordRegex.test(this.passwordConfirm)
    },
    passwordIdentical() {
      return this.password === this.passwordConfirm
    },
    passwordInf() {
      return this.$t('ManageIdentity.Views.Account.Register.Password')
    },
    termsModalTitle() {
      return this.$t('ManageIdentity.Views.Account.Terms.Headline')
    },
    termsTitle() {
      return this.$t('ManageIdentity.Views.Account.Register.Terms')
    },
    dataProtectionTitle() {
      return this.$t('ManageIdentity.Views.Account.Register.Data')
    },
    termsTitleOrg() {
      return this.$t('ManageIdentity.Views.Account.Register.TermsCustom')
    },
    dataProtectionTitleOrg() {
      return this.$t('ManageIdentity.Views.Account.Register.DataCustom')
    },
  },
  methods: {
    async handleAccountTransfer() {
      const data = {
        Email: this.userData.email,
        Encrypted: this.userData.encryptedEmail,
        ManageUserId: this.userData.encryptedUserId,
        Password: this.password,
        ConfirmPassword: this.passwordConfirm,
        AcceptTermsOfUse: this.acceptTermsOfUse,
      }
      
      await this.transferAccount(data).then(async (res) => {
        this.passwordInfo = false
        if (res.status === 404 || res.status === 400 || res.status === 401) this.showInvalidAlert(res.status)
        if (res.token) {
          this.submitted = true
          this.confirmationSend = true
          
          if (this.withSso) {
            this.responseData.token = res.token
            this.responseData.redirectUrl = res.redirectUrl
            await this.ssoSetTokenData(this.responseData)
          }
        }        
      }).catch((err) => console.log(err))
    },
    openPasswordInfo() {
      this.passwordInfo = true
    },
    async openModal(params) {
      this.termsModal.show = true
      if (params) {
        this.loadTermsAndConditions()
        this.acceptTermsOfUse = false
      }
    },
    showInvalidAlert(params) {
      if (params === 404) this.alertData = this.invalidText
      if (params === 400) this.alertData = this.badrequestText
    },
    toggleShow() {
      this.showPassword = !this.showPassword
    },
    toggleShowConfirm() {
      this.showPasswordConfirm = !this.showPasswordConfirm
    },
    redirectToUserSync() {
      if (this.withSso) {
        const url = utils.appendDefaultParamsToRoute({ path: 'correlate/userdatasync' })
        this.$router.replace(url)
      }
      else {
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .transfer-user__container {
    padding: 50px 0;
    overflow: hidden;
    background-color: #ffffff;

    .row {
      justify-content: center;

      //#transfer-user__confirm-password {
      .password-input-container {
        margin-bottom: 10px;
      }
    }

    .terms-card__close-button {
      float: right;
      font-size: 2rem;
      margin-top: -20px;
      cursor: pointer;
    }
  }
  .btn.btn-primary:disabled {
      background-color: rgb(37, 37, 37);
      border-color: rgb(80, 80, 80);
      max-width: 200px;
    }

    .modal-text-scroll {
        max-height: 40vh;
        overflow-y: scroll;
    }

</style>
<style lang="scss">
  .password-input-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: none;
    }
    .btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      svg{
        fill: #fff;
        width: .875rem;
      }
    }
  }
</style>